
      if(["dev", "sit", "sit1", "pre"].includes(window._envsConfig.VITE_APP_ENV)) {
        var script = document.createElement('script')
        script.id = "getPageSpy"
        script.src = window._envsConfig?.STATIC_URL + "/static/PageSpy/getPageSpy-v2.js"
        location.port === '' && document.head.appendChild(script)
      } else {
        // 如果是http协议，则强制跳转到https协议
        var isHttp = window.location.protocol === 'http:'
        if (isHttp) {
          window.location.replace(location.href.replace('http://', 'https://'))
        }
      }
    